<div
  class="form-control-container"
  #wrapper
  [ngStyle]="{ visibility: !attachedToShadowDom() ? 'hidden' : 'visible' }"
>
  <label class="form-control-label" for="selectId">
    {{ isRequired ? label + ' *' : label }}
  </label>

  @if(!isMultiSelect) {
  <p-select
    #select
    inputId="selectId"
    [editable]="false"
    [loading]="loading"
    [showClear]="showClear"
    [filterPlaceholder]="filterPlaceHolder"
    [options]="selectOptions"
    [filter]="filter"
    [disabled]="isDisabled"
    [optionValue]="optionValue"
    [optionLabel]="optionLabel"
    [optionDisabled]="optionDisabled"
    [emptyFilterMessage]="emptyFilterMessage"
    [placeholder]="'Select ' + placeholder"
    [formControl]="selectControl"
    (onShow)="isDropdownOpen = true"
    (onHide)="isDropdownOpen = false"
    (blur)="isFocused = false"
    (focus)="isFocused = true"
    (click)="onClick()"
    [appendTo]="appendToBody ? 'body' : null"
    [virtualScroll]="virtualScroll" 
    [virtualScrollItemSize]="virtualScroll ? 38 : null"
    (onChange)="onSelectChange.emit()"
    [group]="isGrouped"
    [filterBy]="filterBy ? filterBy : optionLabel"
    [dataKey]="optionValue" 
  >
    <ng-template pTemplate="loadingicon">
      <p-progress-spinner 
        strokeWidth="6" 
        styleClass="grey-color"
        [style]="{ width: '16px', height: '16px' }"
      />
    </ng-template>
    <ng-template let-group #group>
        @if(group.label) {
          <div class="flex items-center">
            <span>{{ group.label }}</span>
          </div>
        } @else {
          <span class="ungrouped"></span>
        }
    </ng-template>
  </p-select>
  } @else {
  <p-multiselect
    #multiSelect
    inputId="selectId"
    [loading]="loading"
    [options]="selectOptions"
    [showClear]="showClear"
    [filterPlaceHolder]="filterPlaceHolder"
    [disabled]="isDisabled"
    [optionValue]="optionValue"
    [optionLabel]="optionLabel"
    [optionDisabled]="optionDisabled"
    [emptyFilterMessage]="emptyFilterMessage"
    [placeholder]="'Select ' + placeholder"
    [selectedItemsLabel]="selectedItemsLabel"
    [formControl]="selectControl"
    (onPanelShow)="isDropdownOpen = true"
    (onPanelHide)="isDropdownOpen = false; onCustomSearch('')"
    (blur)="isFocused = false"
    (focus)="isFocused = true"
    [appendTo]="appendToBody ? 'body' : null"
    (click)="onClick()"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="43"
    (onChange)="onSelectChange.emit()"
    (onClear)="onSelectChange.emit()"
    [group]="isGrouped"
    [filterBy]="filterBy ? filterBy : optionLabel"
    [dataKey]="optionValue" 
    [filter]="false"
    [showToggleAll]="false" 
    [showHeader]="false"
  >
    <ng-template pTemplate="selectedItems">
      <span>{{ selectedItemsLabel }}</span>
    </ng-template>
    <ng-template pTemplate="header">
      @if(filter) {
        <div class="p-multiselect-header">
          <p-checkbox 
            [binary]="true" 
            [ngModel]="isAllSelectedSignal()"
            (onChange)="toggleSelectAll($event)"
            ariaLabel="Toggle All"
            [disabled]="!allRawOptions().length"
          />
          <div class="p-multiselect-filter-container">
            <div class="p-iconfield p-iconfield-left">
              
              <input 
                type="text" 
                role="searchbox"
                [placeholder]="filterPlaceHolder" 
                (input)="onCustomSearch(getInputValue($event))"
                class="p-inputtext p-component p-multiselect-filter"
                autocomplete="off"
                (click)="$event.stopPropagation()"
              />
              
              <span class="p-inputicon">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://w3.org" class="p-component p-iconwrapper p-multiselect-filter-icon">
                  <path d="M11.5 6.5C11.5 9.26142 9.26142 11.5 6.5 11.5C3.73858 11.5 1.5 9.26142 1.5 6.5C1.5 3.73858 3.73858 1.5 6.5 1.5C9.26142 1.5 11.5 3.73858 11.5 6.5Z" stroke="currentColor" stroke-width="1"/>
                  <path d="M10 10L13 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </span>

            </div>
          </div>

        </div>
      }
      
    </ng-template>

    <ng-template pTemplate="loadingicon">
      <p-progress-spinner 
        strokeWidth="6" 
        styleClass="grey-color"
        [style]="{ width: '16px', height: '16px' }"
      />
    </ng-template>


    <ng-template let-group #group>
      @if(group.label) {
        <div class="flex items-center">
            <span>{{ group.label }}</span>
        </div>
      } @else {
        <span class="ungrouped"></span>
      }
    </ng-template>
</p-multiselect>
  } @if (selectControl.invalid && selectControl.touched && !isDropdownOpen) {
  <div>
    <p class="form-control-error-message">This field is required.</p>
  </div>
  } @if (hint() && isFocused && !permanentHint()) {
  <div>
    <p class="form-control-hint-message">{{ hint() }}</p>
  </div>
  } @if (hint() && permanentHint() && !selectControl.invalid) {
  <div>
    <p class="form-control-hint-message">{{ hint() }}</p>
  </div>
  }
</div>
